module.exports = __webpack_public_path__ + "static/media/greenArrow.06892183.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/greenArrow.svg
// module id = 1926
// module chunks = 0